import React from 'react'
import PropTypes from 'prop-types'

import Button from '../Button/Button'
import CartLoader from '../Cart/Cart.loader'
import MenusLoader from '../Menus/Menus.loader'
import MenuPageLayout from './MenuPageLayout/MenuPageLayout'
import Modal from '../Modal/Modal'
import RestaurantHeaderLoader from '../RestaurantHeader/RestaurantHeader.loader'

import Warning from '../../assets/warning-outline.svg'
import './MenuPage.error.css'
import { formatPhoneNumber } from '../../utils/phone-number'

const MenuPageError = ({ retry, restaurantInfo }) => {
  const phoneNumber = restaurantInfo ? restaurantInfo.restaurant.location.phone : null
  return (
    <MenuPageLayout
      menus={
        <div styleName='error'>
          <Modal responsive={false}>
            <div styleName='modal'>
              <Warning />
              <h1 styleName='header'>Unable to load restaurant</h1>
              <p styleName='text'>Our system is having an issue loading the restaurant right now.</p>
              <p styleName='text'>Please try again in a few minutes or contact the restaurant to order. {phoneNumber && <a href={`tel:${phoneNumber}`}>{formatPhoneNumber(phoneNumber)}</a>}</p>
              <Button onClick={retry} style='linkWide'>Try Again</Button>
            </div>
          </Modal>
          <RestaurantHeaderLoader />
          <MenusLoader />
        </div>
      }
      cart={<CartLoader />}
    />
  )
}

MenuPageError.propTypes = {
  retry: PropTypes.func,
  restaurantInfo: PropTypes.object
}

export default MenuPageError
